// eslint-disable-next-line no-use-before-define
import React from 'react';
import { capitaliseNameInital } from '$/libraries/capitalise-name-initial';

const { png: emojis } = require('$/components/user_profile/emoji_meta');
const { png: hats } = require('$/components/user_profile/hat_meta');

export function leaderboardPlayerImages(name: string) {
  const normalise = (value: string) => value.trim().replace(/\s+/g, ' ').toLowerCase();
  const playerName = normalise(name);
  const emoji = Object.keys(emojis).find((key) => {
    const baseName = capitaliseNameInital(key);
    return playerName === normalise(baseName) || Object.keys(hats).some((hat) => playerName === normalise(baseName + ' ' + capitaliseNameInital(hat)));
  });
  if (!emoji) return null;
  const hat = Object.keys(hats).find((key) => playerName === normalise(capitaliseNameInital(emoji) + ' ' + capitaliseNameInital(key)));
  return { emoji: emojis[emoji], hat: hat ? hats[hat] : null };
}

export const LeaderboardPlayerAvatar = ({ name }: { name: string }) => {
  const images = leaderboardPlayerImages(name);
  return (
    <span className={`weekly-avatar ${images ? 'weekly-avatar-custom' : ''}`} aria-hidden="true">
      {images ? (
        <>
          <span className="weekly-avatar-face"><img className="weekly-avatar-emoji" src={images.emoji} alt="" /></span>
          {images.hat && <img className="weekly-avatar-hat" src={images.hat} alt="" />}
        </>
      ) : name.slice(0, 2).toUpperCase()}
    </span>
  );
};
